import { render, staticRenderFns } from "./PrizeForm.vue?vue&type=template&id=de77bfe6"
import script from "./prize-form.ts?vue&type=script&lang=ts&external"
export * from "./prize-form.ts?vue&type=script&lang=ts&external"
import style0 from "./prize-form.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports